export const servicePossibility = [
	// Прием платежей в мобильном приложении
	{
		name: 'Mobile SDK',
		location: 'Возможности: Оплата в приложении',
		url: '/features/mobile#block1',
	},
	{
		name: 'Как принимать платежи в мобильном приложении?',
		location: 'Возможности: Оплата в приложении',
		url: '/features/mobile#block2',
	},
	{
		name: 'Как работают платежи через мобильный SDK?',
		location: 'Возможности: Оплата в приложении',
		url: '/features/mobile#block3',
	},
	// Безопасная сделка
	{
		name: 'Безопасная сделка',
		location: 'Возможности: Безопасная сделка',
		url: '/features/safe-deal#block1',
	},
	{
		name: 'Прозрачный процесс расчетов',
		location: 'Возможности: Безопасная сделка',
		url: '/features/safe-deal#block1Title1',
	},
	{
		name: 'Заморозка денег до 2 месяцев',
		location: 'Возможности: Безопасная сделка',
		url: '/features/safe-deal#block1Title2',
	},
	{
		name: 'Монетизация сделок для онлайн-площадок',
		location: 'Возможности: Безопасная сделка',
		url: '/features/safe-deal#block1Title3',
	},
	{
		name: 'Защита от мошенников',
		location: 'Возможности: Безопасная сделка',
		url: '/features/safe-deal#block1Title4',
	},
	{
		name: 'Как работает безопасная сделка',
		location: 'Возможности: Безопасная сделка',
		url: '/features/safe-deal#block2',
	},
	// Рекуррентные платежи
	{
		name: 'Рекуррентные платежи',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block1',
	},
	{
		name: 'Как работают подписки?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block2',
	},
	{
		name: 'Регулярные платежи под ключ: сервис подписок от CloudPayments',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block3',
	},
	{
		name: 'Кому полезен сервис подписок от CloudPayments?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block4',
	},
	{
		name: 'Как подключить рекуррентные платежи?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block5',
	},
	{
		name: 'FAQ',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6',
	},
	{
		name: 'Могут ли ИП и ООО принимать платежи по подписке и что нужно учесть при подключении?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title1',
	},
	{
		name: 'Какие платежные методы доступны для рекуррентных платежей?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title2',
	},
	{
		name: 'Возможно ли перенести уже существующие данные подписчиков на рекурренты от CloudPayments?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title3',
	},
	{
		name: 'Нужно ли бизнесу заключать специальный договор с конечным пользователем, чтобы он подписался?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title4',
	},
	{
		name: 'Что произойдет, если при списании платежа по подписке на банковской карте клиента недостаточно средств или истек срок действия карты?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title5',
	},
	{
		name: 'Могу ли я отработать чарджбэки?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title6',
	},
	{
		name: 'Могу ли я отработать чарджбэки?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title6',
	},
	{
		name: 'Работают ли автоматические списания на Tilda?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title6',
	},
	{
		name: 'Можно ли подключить рекуррентные платежи к GetCourse?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title6',
	},
	{
		name: 'Есть ли решение для крупного бизнеса для самостоятельного контроля подписок?',
		location: 'Возможности: Рекуррентные платежи',
		url: '/features/recurrent#block6Title6',
	},
	// Рекарринг
	{
		name: 'Рекарринг',
		location: 'Возможности: Рекарринг',
		url: '/features/recurring#block1',
	},
	{
		name: 'Как работают платежи в один клик?',
		location: 'Возможности: Рекарринг',
		url: '/features/recurring#block2',
	},
	{
		name: 'Как подключить рекарринг?',
		location: 'Возможности: Рекарринг',
		url: '/features/recurring#block3',
	},
	// AFT
	{
		name: 'AFT-платежи',
		location: 'Возможности: AFT',
		url: '/features/aft#block1',
	},
	// Оплата по ссылке
	{
		name: 'Прием платежей по ссылке',
		location: 'Возможности: Оплата по ссылке',
		url: '/features/pay-link#block1',
	},
	{
		name: 'Как принимать оплату по ссылке без сайта?',
		location: 'Возможности: Оплата по ссылке',
		url: '/features/pay-link#block2',
	},
	{
		name: 'Преимущества платежной ссылки',
		location: 'Возможности: Оплата по ссылке',
		url: '/features/pay-link#block3',
	},
	{
		name: 'Где можно применять ссылку на оплату?',
		location: 'Возможности: Оплата по ссылке',
		url: '/features/pay-link#block4',
	},
	{
		name: 'Прием платежей в Инстаграм',
		location: 'Возможности: Оплата по ссылке',
		url: '/features/pay-link#block4Title1',
	},
	{
		name: 'Прием платежей в Telegram',
		location: 'Возможности: Оплата по ссылке',
		url: '/features/pay-link#block4Title2',
	},
];
